import { createFileRoute } from '@tanstack/react-router'

import { SettingsIndex } from '@/features/settings/settings-index'

export const Route = createFileRoute('/_app/settings/')({
  component: SettingsIndex,
})
